import { useState } from "react";

// material ui components
import Alert from "@mui/material/Alert";

// components
import formModel from "./formModel";
import { loginUser } from "../../../../setup/context/api";
import { contextUserLogin } from "../../../../setup/context/authContext";
import { IUserLoginResponse } from "../../../../setup/api/services/auth/models";
import { Form, Formik } from "formik";
import initialValues from "./initialValues";
import CustomizedSnackbars from "../../../../components/customizedSnackbars";
import {
  LOGIN,
  LOGIN_FORM_HEADERS,
  LOGIN_RESPONSE_ERROR,
} from "../../constants";
import { useTranslation } from "react-i18next";
import TextInput, { InputType } from "../../../../components/forms/textInput";
import PrimaryButton from "../../../../components/common/PrimaryButton";
import Spinner from "../../../../components/common/Spinner";

const LoginForm = () => {
  const { t } = useTranslation();

  const { formId } = formModel;
  const [error, setError] = useState<string>();
  const [userName, setUserName] = useState<string>("");
  const [password, setPassword] = useState<string>("");
  const [snackBarOpen, setSnackBarOpen] = useState<boolean>(false);
  const [loading, setLoading] = useState(false);

  const _handleSubmit = (e) => {
    e?.preventDefault();
    const formData = new FormData();
    formData.append("username", userName);
    formData.append("password", password);
    login(formData);
  };

  const login = (formData: FormData) => {
    setLoading(true);
    loginUser(formData)
      .then((res: IUserLoginResponse) => {
        contextUserLogin(res);
        window.location.reload();
        setLoading(false);
      })
      .catch(() => {
        setSnackBarOpen(true);
        setError(LOGIN_RESPONSE_ERROR);
        setLoading(false);
      });
  };
  const onEmailChanged = (event) => {
    setUserName(event.target.value);
  };
  const onPasswordChanged = (event) => {
    setPassword(event.target.value);
  };
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
        alignItems: "center",
        marginTop: "64px",
        width: "100%",
        padding: "0 16px",
      }}>
      {snackBarOpen && (
        <CustomizedSnackbars
          open={snackBarOpen}
          title={LOGIN_RESPONSE_ERROR}
          type={"error"}
        />
      )}
      <Formik
        enableReinitialize={true}
        initialValues={initialValues}
        onSubmit={_handleSubmit}>
        <Form id={formId} style={{ width: "100%", maxWidth: "534px" }}>
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "32px",
              width: "100%",
            }}>
            <h1 style={{ marginBottom: "16px" }}>{t("lbl_login_title")}</h1>
            {error && <Alert severity="error">{error}</Alert>}
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                gap: "14px",
                width: "100%",
              }}>
              <TextInput
                onChange={onEmailChanged}
                value={userName}
                placeholder={LOGIN_FORM_HEADERS.EMAIL}
                label={LOGIN_FORM_HEADERS.EMAIL}
                dir="ltr"
              />

              <TextInput
                placeholder={LOGIN_FORM_HEADERS.PASSWORD}
                label={LOGIN_FORM_HEADERS.PASSWORD}
                value={password}
                onChange={onPasswordChanged}
                type={InputType.PASSWORD}
              />
            </div>
            <PrimaryButton
              disabled={loading || !userName || !password}
              type="submit"
              onClick={_handleSubmit}
              style={{
                width: "100%",
                height: "52px",
                borderRadius: "8px",
                background:
                  loading || !userName || !password ? "#E2E5EE" : "#0D44AD",
                textAlign: "center",
                whiteSpace: "nowrap",
                fontSize: "14px",
                lineHeight: "100%",
                fontWeight: 500,
              }}>
              {loading ? <Spinner /> : `${LOGIN}`}
            </PrimaryButton>
          </div>
        </Form>
      </Formik>
    </div>
  );
};

export default LoginForm;
